<template>
    <div class="card" id="tasks-activity">
        <div class="card-header">
            <span class="fa fa-sticky-note"></span> {{trans('tasks.cards.header.activity')}}
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-12">
                    <div class="direct-chat direct-chat-primary" v-chat-scroll >
                        <div v-for="item in items"
                             :class="'direct-chat-msg' + (user.id === item.user_id ? ' right' : '')">
                            <div class="direct-chat-info clearfix">
                                <span :class="'direct-chat-name' + (user.id === item.user_id ? ' pull-right' : ' pull-left')"><strong
                                        v-if="item.duration">{{item.duration}} hours | </strong> {{ item.owner.full_name }}</span>
                                <span :class="'direct-chat-timestamp'  + (user.id === item.user_id ? ' pull-left' : ' pull-right')">{{renderDate(item.updated_at)}}</span>
                            </div>
                            <!-- /.direct-chat-info -->
                            <img class="direct-chat-img" :src="item.owner.photo_url"
                                 :alt="item.owner.full_name"><!-- /.direct-chat-img -->
                            <div class="direct-chat-text">
                                <p v-if="item.duration !== undefined">
                                    {{item.description}}
                                </p>
                                <p v-else>{{item.text}}</p>
                            </div>
                            <div class="clearfix" v-if="item.duration === undefined">
                                <button v-if="item.user_id === user.id"
                                        class="btn btn-sm pull-right btn-outline-danger btn-remove"
                                        @click="deleteItem(item)">Remove
                                </button>
                            </div>
                            <!-- /.direct-chat-text -->
                        </div>
                    </div>
                </div>
            </div>

            <div class="row" v-if="!task.done" v-loading="loading">
                <div class="col-12">
                    <textarea v-on:keyup.enter="submit" rows="2" id="text" v-model="text" name="text"
                              class="form-control" placeholder="Write a comment..."></textarea>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    let moment = require('moment');
    import _ from 'lodash';

    export default {
        name: "task-activity",
        props: {
            task: Object,
            user: Object,
        },
        data() {
            return {
                loading: false,
                text: '',
                data: [],
            }
        },
        computed: {
            items: function () {
                let items = [];
                items = _.merge(items, this.data.comments);
                items = _.merge(items, this.data.timers);

                return _.sortBy(items, function (item) {
                    return moment(item.updated_at);
                });
            },
        },
        mounted() {
            this.loadComments();
        },
        methods: {
            renderDate: function (date) {
                if (moment(date).isValid()) {
                    return moment(date).fromNow();
                }
                return '';
            },
            trans: function (path) {
                return Lang.trans(path);
            },
            loadComments() {
                let vm = this;
                vm.loading = true;
                axios.get(laroute.route('task.comments', {task: this.task.id}))
                    .then(response => {
                        vm.data = response.data;
                        vm.loading = false;
                    }).catch(error => {
                    console.log(error);
                })
            },
            deleteItem: function (item) {
                // var resource = this.$resource('/visi/api/project-notes{/id}');
                let vm = this;
                var r = confirm("Are you sure to delete this comment?");
                if (r == true) {
                    vm.loading = true;
                    axios.delete(laroute.route('task.comments.delete', {task: this.task.id, comment: item.id}))
                        .then(response => {
                            vm.comments = response.data;
                            vm.loading = false;
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }

            },
            submit() {
                let vm = this;
                vm.loading = true;
                let text = vm.text;
                vm.text = '';

                axios.post(laroute.route('task.comments', {task: this.task.id}), {
                    text: text,
                })
                    .then(response => {
                        vm.data = response.data;
                        vm.loading = false;
                    })
                    .catch(error => {
                        console.log(error);
                    })
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/tasks/TaskActivity.vue